<template>
  <div>
    <div class="row-width-actions-bar is-border-top">
      <div class="columns is-gapless">
        <div class="column is-padding-left-small is-self-centered columns is-gapless is-vcentered">
          <div class="column">
						<span class="is-size-6">
							<input v-if="isAdmin || isSectorManager" :id="idx + '-choice-name'"
                     class="input is-borderless is-small is-fullwidth"
                     placeholder="Titre liste"
                     type="text" v-model="choice.name" @change="commitAdv"
                     :disabled="!canEdit">
              <span v-else-if="!(isAdmin || isSectorManager) && !choice.name" class="input is-borderless is-small is-fullwidth has-text-grey">Titre liste</span>
              <span v-else-if="!(isAdmin || isSectorManager) && choice.name" class="input is-borderless is-small is-fullwidth">{{choice.name}}</span>
						</span>
          </div>
        </div>
        <div v-if="!this.choice.document && (isAdmin || isSectorManager)" class="column is-narrow is-border-left">
          <label class="page-header-btn is-small is-square tooltip is-tooltip-top" data-tooltip="Lier un document">
            <input class="file-input" type="file" accept='image/png, image/jpeg, .pdf' @change="processFile($event)"
                   name="resume">
            <span class="is-marginless icon is-size-4">
              <i v-if="!uploading" class="fal fa-link"></i>
              <i v-else class="fas fa-spinner fa-pulse"></i>
            </span>
          </label>
        </div>
        <template v-else>
          <div v-if="seeDoc" class="column is-narrow has-bg-white is-border-left is-flex is-padding-small">
            <a @click="download()" class="icon has-text-grey is-self-centered tooltip is-tooltip-top" data-tooltip="Télécharger"><i class="fal fa-download"></i></a>
          </div>
          <div v-if="isAdmin || isSectorManager" class="column is-narrow has-bg-white is-border-left is-flex is-padding-small">
            <a @click="unlink()" class="icon has-text-grey is-self-centered tooltip is-tooltip-top" data-tooltip="Supprimer document lié"><i class="fal fa-unlink"></i></a>
          </div>
        </template>
        <div v-if="idx > 0 && (isAdmin || isSectorManager)" class="column is-narrow is-border-left">
          <button @click="deleteList()" class="page-header-btn is-small is-square tooltip is-tooltip-top" data-tooltip="Supprimer la liste"><span
            class="icon is-size-4"><i class="fal fa-trash-alt"></i></span></button>
        </div>
      </div>
    </div>
    <div v-if="!openWysi" class="vadDiscussion is-border-top">
      <div
        class="vadDiscussion--bulle is-size-6 is-min-height-50 vadDiscussion--bulle--has-actions is-cut is-padding-left">
        <div class="content" v-if="choice.comment" v-html='choice.comment'></div>
        <div class="content" v-else>Aucun commentaire</div>
        <div class="actionsOnRow actionsOnRow--vertical">
          <div v-if="(isAdmin || isSectorManager)" class="">
            <button @click="openWysiwyg()" class="is-min-height-full">
              <span class="icon is-small"><i class="fal fa-edit"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="is-border-top columns is-gapless">
      <div class="column">
        <wysiwyg-editor
          :light='true' :tooltip-top="true"
          :model="commentaire"
          @change="val => commentaire = val"
          class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
        </wysiwyg-editor>
      </div>
      <div class="actionsOnRow actionsOnRow--vertical">
        <div>
          <button type="button" class="button is-success" @click="editComment">
            <span class="icon is-small"><i class="fal fa-save"></i></span>
          </button>
        </div>
        <div class="">
          <button type="button" class="actionsOnRow-btn--hoverIsDanger" @click="openWysi = false">
            <span class="icon is-small"><i class="fal fa-times"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'ChoixList',
    props: {
      source: {
        type: Object,
        required: true
      },
      canEdit: Boolean,
      idx: Number
    },
    data () {
      return {
        openWysi: null,
        choice: null,
        commentaire: null,
        uploading: false
      }
    },
    computed: {
      ...mapGetters(['isAdmin', 'isSectorManager']),
      seeDoc () {
        if (this.isAdmin || this.isSectorManager) return true
        else if ('document' in this.choice && this.choice.document) {
          if ('display' in this.choice.document && this.choice.document.display) return true
          else return false
        } else {
          return false
        }
      }
    },
    methods: {
      openWysiwyg () {
        this.openWysi = true
        this.$nextTick(() => {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.getElementsByClassName('ql-editor')
          contenteditable = contenteditable[this.idx]
          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
        })
      },
      deleteList () {
        this.$emit('deleteList', this.idx)
      },
      commitAdv () {
        this.$emit('commitAdv')
      },
      editComment () {
        this.$set(this.choice, 'comment', this.commentaire)
        this.$emit('saveAdv')
        this.$nextTick(() => {
          this.openWysi = false
        })
      },
      async processFile (event) {
        let file = event.target.files[0]
        let files = new FormData()
        files.append('file[]', file, file.name)
        this.uploading = true
        let document = null
        try {
          let res = await this.$fus.post({ data: files })
          document = res.data[0]
          document.fus_id = document.id
        } catch (e) {
          console.log(e)
        }
        if (document) {
          this.$set(this.choice, 'document', document)
          this.commitAdv()
          this.uploading = false
        }
      },
      download () {
        let link = document.createElement('a')
        link.href = this.choice.document.path
        link.target = '_blank'
        link.click()
      },
      unlink () {
        this.$set(this.choice, 'document', null)
        this.commitAdv()
      }
    },
    created () {
      if (this.isAdmin || this.isSectorManager) {
        this.openWysiwyg()
      } else {
        this.openWysi = false
      }
      this.choice = this.source
      if (this.choice.comment) {
        this.commentaire = this.choice.comment
      }
      if (this.choice.name === null) {
        this.choice.name = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/ChoixList.vue